/**
 * 유입 경로 — 페이지 조회 이벤트에 싣는 `ref` · UTM · referrer.
 * @description `ref` 는 대표님 가이드가 명시한 유입 추적용 쿼리다(`?ref=ig_story`). 같은 링크를
 *   인스타 · X · DM 에 뿌리고 어디서 왔는지 가르는 것이 콜랩 페이지의 존재 이유다. 콜랩 상세가
 *   싣는다. 이벤트마다 같은 키로 싣도록 한 곳에 둔다.
 * @example trackEvent("Collab Viewed", { ...props, ...referrers() })
 */
export function referrers(): Record<string, unknown> {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  return {
    ref: params.get("ref") ?? undefined,
    utm_source: params.get("utm_source") ?? undefined,
    utm_medium: params.get("utm_medium") ?? undefined,
    utm_campaign: params.get("utm_campaign") ?? undefined,
    referrer: document.referrer || undefined,
  };
}
